export default __webpack_public_path__ + "static/inner-belief_small-image_4-77714ea1e200664a3e9fabaee5ee4916.webp";